import {
  FETCH_COOLDOWN_BY_TASK_REQUEST,
  FETCH_COOLDOWN_BY_TASK_SUCCESS,
  FETCH_COOLDOWN_BY_TASK_FAILURE,
} from './cooldownByTaskTypes';

const initialState = { loading: false, cooldownByTask: null, error: '' };

const cooldownByTaskReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_COOLDOWN_BY_TASK_REQUEST:
      // Clear any previously loaded recording as soon as a new fetch starts.
      // Without this, switching from one cooldown task to another can render
      // the first task's readings under the second task's popup for the
      // whole fetch window — these are food-safety records, so that gap
      // matters even if it is usually brief.
      return { loading: true, cooldownByTask: null, error: '' };
    case FETCH_COOLDOWN_BY_TASK_SUCCESS:
      return { loading: false, cooldownByTask: action.payload, error: '' };
    case FETCH_COOLDOWN_BY_TASK_FAILURE:
      return { loading: false, cooldownByTask: null, error: action.payload };
    default:
      return state;
  }
};

export default cooldownByTaskReducer;
